import { FunctionComponent } from 'react';

import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
} from '@kanda-libs/ks-design-library';

import CompanyTable from 'components/company/CompanyTable';

import CompaniesListPageInfoBanner from './CompaniesListPageInfoBanner';
import useCompaniesListPage from './useCompaniesListPage';

const CompaniesListPage: FunctionComponent = () => {
  const toggleValue = useCompaniesListPage();
  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <CompaniesListPageInfoBanner toggleValue={toggleValue} />
        <CompanyTable />
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default CompaniesListPage;
